<div class="profile-page bg-secondary">
  <main class="pt-4">
    <div class="container wow fadeIn">
      <!--Grid row-->
      <div class="row">
        <div class="table-responsive">
          <table class="table table-bordered table-hover table-striped ">
            <thead>
              <tr>
                <th>Date</th>
                <th>Description</th>
                <th>Item Name</th>
                <th>Amount</th>
                <th>Total discount</th>
                <th>Balance</th>
                <th>Sold by</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in walletTransactionsDto[0]">
                <td>{{new Date(item.updatedOn).toLocaleString()}}</td>
                <td>{{item.description}}</td>
                <td>{{item.itemName}}</td>
                <td>{{item.amount}}</th>
                <td>{{item.discountTotalAmount}}</td>
                <td>{{item.balance}}</td>
                <td>{{item.userName}}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <!--Grid row-->
    </div>
  </main>
  <!--spinner-->
  <div class="vld-parent">
    <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="true"></loading>
  </div>
  <!--spinner-->
  <!--Main layout-->
</div>